import { Menu } from "antd";
import {
  InfoCircleOutlined,
  MailOutlined,
  ProductOutlined,
  CalendarOutlined,
  TeamOutlined,
  DollarOutlined,
} from "@ant-design/icons";

const itemsleft = [
  {
    label: <a href="/about">Hakkımızda</a>,
    key: "about",
    icon: <InfoCircleOutlined />,
  },
  {
    label: (
      <a href="/forum">
        <TeamOutlined style={{ marginRight: "10px" }} />
        Forum
      </a>
    ),
    key: "forum",
  },
  {
    label: <a href="/contact">İletişim</a>,
    key: "contact",
    icon: <MailOutlined />,
  },
];
const itemsright = [
  {
    label: (
      <a style={{ color: "inherit" }} href="/shares">
        <DollarOutlined style={{ marginRight: "10px" }} />
        Hisseler
      </a>
    ),
    key: "shares",
    children: [
      {
        label: (
          <h3 style={{ marginTop: "0", color: "var(--darkoth)" }}>
            <a href="/shares#buy">Hisse al</a>
          </h3>
        ),
        key: "shares:buy",
      },
    ],
  },
  {
    label: (
      <a style={{ color: "inherit" }} href="/projects">
        <ProductOutlined style={{ marginRight: "10px" }} />
        Projeler
      </a>
    ),
    key: "projects",
    children: [
      {
        label: (
          <h3 style={{ marginTop: "0", color: "var(--darkoth)" }}>
            <a href="/projects/ChatRivo">ChatRivo</a>
          </h3>
        ),
        key: "projects:1",
      },
      {
        label: (
          <h3 style={{ marginTop: "0", color: "var(--darkoth)" }}>
            <a href="/projects/MisToDo">Mis To Do</a>
          </h3>
        ),
        key: "projects:2",
      },
    ],
  },
  {
    label: (
      <a style={{ color: "inherit" }} href="/events">
        <CalendarOutlined style={{ marginRight: "10px" }} />
        Etkinlikler
      </a>
    ),
    key: "events",
    children: [
      {
        label: (
          <h3 style={{ marginTop: "0", color: "var(--darkoth)" }}>
            <a href="/events/chatrivo">ChatRivo'nun Çıkışı!</a>
          </h3>
        ),
        key: "events:1",
      },
      { label: <a href="/events">Yaklaşan Etkinlikler</a>, key: "events:2" },
    ],
  },
];
function Nav(args) {
  return (
    <nav
      style={{
        display: "flex",
        paddingTop: args.device === "phone" && ".5rem",
        flexDirection: args.direction,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Menu
        className={`h_div ${!(args.device === "phone") ? "left" : ""}`}
        onClick={(e) => args.setCurrent(e.key)}
        style={{
          flexDirection: args.direction,
          backgroundColor: "transparent",
          fontSize: args.device === "pc" ? "1.5rem" : "1.2rem",
          minWidth: args.mode === "vertical" && "100%",
        }}
        selectedKeys={[args.current]}
        mode={args.mode}
        items={itemsleft}
      />
      <Menu
        className={`h_div ${!(args.device === "phone") ? "right" : ""}`}
        onClick={(e) => args.setCurrent(e.key)}
        style={{
          flexDirection: args.direction,
          backgroundColor: "transparent",
          fontSize: args.device === "pc" ? "1.5rem" : "1.2rem",
          minWidth: args.mode === "vertical" && "100%",
        }}
        selectedKeys={[args.current]}
        mode={args.mode}
        items={itemsright}
      />
    </nav>
  );
}

function Sidebar(args) {
  return (
    <div
      className={`sidebar ${args.menu ? "sidebar-open" : ""}`}
      style={{
        visibility: !(args.device === "phone") ? "hidden" : "visible",
        boxShadow: "var(--shadow-s",
        zIndex: "-1",
      }}
    >
      <Nav
        direction="column"
        mode="vertical"
        device={args.device}
        current={args.current}
        setCurrent={args.setCurrent}
      ></Nav>
    </div>
  );
}

export { Sidebar, Nav };
